<header class="flex items-center h-16 px-2 sm:px-4 md:px-6 bg-white shadow border-b">
  <!-- Bouton menu visible uniquement jusqu'à lg -->
  <div class="lg:hidden mt-1.5 mr-4">
    <button (click)="toggleSidebar.emit()">
      <mat-icon class="text-[#B0C3CC]" svgIcon="mat_outline:menu"></mat-icon>
    </button>
  </div>

  <!-- Titre dynamique -->
  <div class="flex-1">
    <h1 class="text-[18px] sm:text-[24px] font-bold text-center sm:text-left w-full">
      {{ pageTitle }}
    </h1>
  </div>

  <!-- Bloc utilisateur -->
  <div class="relative flex items-center gap-2">
    <!-- Bouton utilisateur -->
    <button
      mat-button
      [matMenuTriggerFor]="userMenu"
      class="flex items-center gap-2 hover:bg-primary/10 px-4 h-10 rounded-md"
      (menuOpened)="isMenuOpen = true"
      (menuClosed)="isMenuOpen = false"
    >
      <mat-icon class="text-primary w-8 h-8" svgIcon="heroicons_solid:user-circle"></mat-icon>
      <span class="text-[12px] capitalize">{{ userName }}</span>
      <mat-icon
        [svgIcon]="'mat_outline:keyboard_arrow_down'"
        class="w-4 h-4 transition-transform duration-300 ease-in-out text-[#B0C3CC]"
        [ngClass]="{ 'rotate-180': isMenuOpen }"
      ></mat-icon>
    </button>

    <!-- Menu utilisateur -->
    <mat-menu #userMenu="matMenu">
      <button class="text-[12px]" mat-menu-item (click)="logout()">
        <mat-icon svgIcon="mat_solid:logout"></mat-icon>
        <span>Déconnexion</span>
      </button>
    </mat-menu>

    <!-- Bouton notifications -->
    <button
      mat-button
      class="flex items-center justify-center hover:bg-primary/10 px-4 h-10 rounded-md"
    >
      <mat-icon class="text-[#B0C3CC] w-5 h-5" svgIcon="mat_solid:notifications"></mat-icon>
    </button>
  </div>
</header>
